import fileSaver from "file-saver";

export default {
    getFilename(file) {
        return file.name;
    },
    getFilenameFromUrl(url) {
        return url.split('/').pop();
    },
    // Get the filesize in bytes from the File object
    getFilesize(file) {
        return file.size; // Returns the size in bytes
    },
    formatedFilesize(bytes, decimals) {
        if (bytes == 0) return '0 Bytes';
        var k = 1024,
            dm = decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    // Get the file extension from the File object
    getFileExtension(file) {
        return this.getFileNameExtension(file.name);
    },
    getFileNameExtension(fileName) {
        return fileName.split('.').pop().toLowerCase(); // Returns the file extension in lowercase
    },
    // Get the content type (MIME type) from the File object
    getContentType(file) {
        let mimeType = file.type;

        // Fallback for common file types based on extension if MIME type is empty
        if (!mimeType) {
            const extension = this.getFileExtension(file);
            mimeType = this.getMimeTypeFromExtension(extension);
        }

        return mimeType;
    },
    convertToUploadFile(file){                    
        return {
            Name: file.name,
            Url: file.url
        };                
    },
    convertToUploadFiles(files){
        var new_files = [];
        for(var i = 0; i < files.length; i++){
            var file = files[i];
            new_files.push(this.convertToUploadFile(file));
        }
        return new_files;
    },
    getMimeTypeFromExtension(extension) {
        const mimeTypes = {
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'webp': 'image/webp',
            'pdf': 'application/pdf',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'ppt': 'application/vnd.ms-powerpoint',
            'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'txt': 'text/plain',
            'csv': 'text/csv',
            'html': 'text/html',
            'css': 'text/css',
            'js': 'application/javascript',
            'json': 'application/json',
            'zip': 'application/zip',
            'rar': 'application/x-rar-compressed',
            'mp3': 'audio/mpeg',
            'mp4': 'video/mp4',
            'avi': 'video/x-msvideo',
            'se': 'text/sie',
            'sie': 'text/sie'
            // Add other common extensions as needed
        };

        return mimeTypes[extension] || 'application/octet-stream'; // Default to 'application/octet-stream' for unknown types
    },
    async fetchFile(url, fileName)
    {
         // Perform request using fetch
        const response = await fetch(url, {
            method: "GET",
            timeout: 1200000 // Fetch API does not support timeout natively
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
        }

        // Convert response to Blob
        const blob = await response.blob();
        const fileURL = URL.createObjectURL(blob);

        // Determine MIME type
        let mimeType = this.getMimeTypeFromExtension(this.getFileNameExtension(fileName));
        // Create File object
        return { File: new File([blob], fileName, { type: mimeType}), blob: blob, fileURL: fileURL };
    },
    async fetchFileAndDownload(url, fileName)
    {
        var file = await this.fetchFile(url, fileName); // Fetch file from URL
        fileSaver.saveAs(file.File); // Trigger save
    },
    async base64Download(base64Data, filename)
    {
        // Convert base64 into File object
        var mime = "application/pdf;charset=utf-8",
            bstr = atob(base64Data), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--)
        {
            u8arr[ n ] = bstr.charCodeAt(n);
        }
        var file = new File([ u8arr ], filename, { type: mime });

        fileSaver.saveAs(file); // Trigger save
    },
    saveUrl(url, fileName) {
        fileSaver.saveAs(url, fileName); // Trigger save
    },
    async openUrlInNewTab(fileUrl) {
        const response = await this.fetchFile(fileUrl, fileUrl);        
        // Open in a new tab
        window.open(response.fileURL, '_blank');
    }
} 